export const changePageTitle = (title) => {
	document.title = title || 'IQ Education';
};
